import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFormatTitlecase = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 21,
	fill: "none",
	viewBox: "0 0 20 21",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fill: "#000",
		d: "M1.044 15.998a.75.75 0 0 0 1.412.504l-1.412-.504ZM5.5 5.75l.706-.252a.75.75 0 0 0-1.412 0l.706.252Zm3.044 10.752a.75.75 0 0 0 1.412-.504l-1.412.504ZM3 12a.75.75 0 0 0 0 1.5V12Zm5 1.5A.75.75 0 0 0 8 12v1.5Zm5-7.75a.75.75 0 0 0-1.5 0H13Zm-1.5 10.5a.75.75 0 0 0 1.5 0h-1.5Zm-9.75 0 .706.252 3.75-10.5L5.5 5.75l-.706-.252-3.75 10.5.706.252ZM5.5 5.75l-.706.252 3.75 10.5.706-.252.706-.252-3.75-10.5-.706.252Zm-2.5 7v.75h5V12H3v.75Zm15.25-.25h-.75c0 1.822-1.155 3-2.25 3V17c2.219 0 3.75-2.18 3.75-4.5h-.75Zm-3 3.75v-.75c-1.095 0-2.25-1.178-2.25-3h-1.5c0 2.32 1.531 4.5 3.75 4.5v-.75Zm-3-3.75H13c0-1.822 1.155-3 2.25-3V8c-2.219 0-3.75 2.18-3.75 4.5h.75Zm3-3.75v.75c1.095 0 2.25 1.178 2.25 3H19c0-2.32-1.531-4.5-3.75-4.5v.75Zm-3-3h-.75v10.5H13V5.75h-.75Z"
	})]
});
const ForwardRef = forwardRef(SvgFormatTitlecase);
export { ForwardRef as ReactComponent };
